import { useEffect } from "react";
import "./Footer.css";
import ButtonContactFooter from "../ButtonContact/ButtonFooter";
import FooterLine from "../../Assets/Svg/Footer/FooterLine.svg";
import IconFB from "../../Assets/Svg/Footer/IconFB.svg";
import IconIns from "../../Assets/Svg/Footer/IconIns.svg";
import IconLinkedin from "../../Assets/Svg/Footer/IconLinkedin.svg";
import FooterLogo from "../../Assets/Svg/Footer/Footer_Logo.svg";
import FooterMapPin from "../../Assets/Svg/Footer/FooterMapPin.svg";
import { useSelector, useDispatch } from "react-redux";
import { fetchFooterData } from "../../redux/FooterSlice";
import { LoaderWrap } from "../GlobalLoader/LoaderWrap";
export default function ArabicFooter() {
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.footer);

  useEffect(() => {
    if (!data || data.length === 0) {
      dispatch(fetchFooterData({ lang: "ar" }));
    }
  }, [dispatch, data]);

  const section1 = data?.find((s) => s.id === 1);
  const section2 = data?.find((s) => s.id === 2);
  const section3 = data?.find((s) => s.id === 3);

  const socialIcons = {
    فيسبوك: IconFB,
    انستجرام: IconIns,
    لينكدان: IconLinkedin,
  };

  return (
    <>
      <LoaderWrap>
        <div className="Footer_ContainerAr">
          <div className="Footer_P1">
            <div className="Footer_P1T1Ar TFut24PxPC">{section1?.title}</div>
            <div className="Footer_P1T2Ar TGLo32PxPC" dir="rtl">
              {section1?.description}
            </div>
            <div>
              {section1?.links && section1?.links.length > 0 && <ButtonContactFooter Text={section1?.links[0]?.name} Path={section1?.links[0]?.link} />}
            </div>
          </div>
          <div className="FooterL">
            <img src={FooterLine} alt="" className="FooterLine" />
          </div>
          {section2 && (
            <div className="Footer_P1">
              <div className="Footer_P2T1Ar TGLo32PxPC">{section2?.title}</div>
              <div className="Footer_P2T2Ar TFut24PxPC">{section2?.description}</div>
              <div className="Footer_P2SC">
                {section2?.links &&
                  section2?.links.map((link, index) => (
                    <a key={index} href={link.link} target="_blank" rel="noopener noreferrer">
                      <img src={socialIcons[link.name.toLowerCase()]} alt={link.name} />
                    </a>
                  ))}
              </div>
            </div>
          )}

          <div className="Footer_P3_B ar">
            <div className="FP3BT TFut24PxPC Footer_P3_BTAr" dir="rtl">
              {section3?.title}
            </div>
            {section3?.links && section3?.links.length > 0 && (
              <a href={section3?.links[0]?.link} target="_blank" rel="noopener noreferrer" className="Footer_P3_BTAr Footer_P3_BT TFut24PxPC">
                <img src={FooterMapPin} alt="Map Pin" className="FooterMapPin" />
                {section3?.links[0]?.name}
              </a>
            )}
          </div>
          <div className="Footer_P4">
            <div>
              <img src={FooterLogo} alt="" className="FooterLogo" />
            </div>
            <div className="Footer_P4TAr TFut20PxPC">@2025 جميع الحقوق محفوظة لـ ميلكيز</div>
          </div>
        </div>
      </LoaderWrap>
    </>
  );
}
